import { isProduction } from '..';
import type { AppConfig } from '../types';

export default {
  zone: 'asia-4',
  defaultLocale: 'id-ID',
  availableLocales: ['en-ID', 'id-ID'],
  timedBanners: {},
  zoneFeatures: {
    AUTO_SELECT_SPLIT_VIEW_FIRST_JOB: false,
    ENTRY_LEVEL_BADGE: true,
    HOMEPAGE_BANNER_TYPE: 'multiple-asia',
    HOMEPAGE_LHS_BANNER_TYPE: 'GENERIC_ASIA_BANNER',
    HOMEPAGE_RHS_BANNER_TYPE: 'MARKETING_BANNER_SEEK_PASS',
    KEYWORD_AUTOSUGGEST_V2: true,
    LMIS_ENABLED: true,
    LOGGED_OUT_RECS: false,
    NUDGE_ENABLED: false,
    REMOTE_SEARCH_FILTER_NEW_LABEL: false,
    REMOTE_SEARCH_FILTER: false,
    SEARCH_PAGE_SIZE: 32,
    SERP_JOBCARD_INFO_DENSITY_1: false,
    SHOW_FLOATING_SAVE_SEARCH: false,
    SHOW_MARKETING_AD_SPLIT_VIEW: true,
  },
  BRANCH_IO_KEY: isProduction
    ? 'key_live_keVW4JKlS0jBJLPfSRNUJnhhtElmK541'
    : 'key_test_igQ77GMmQ1itGVIiMGXzojmavAcg9pio',
  GPT_ACCOUNT_ID: '23210488134',
} as AppConfig;
